// Add a delegated event listener to element, only triggering if the target matches the selector
export const addDelegatedEventListener = (element, event, selector, callback) => {
  element.addEventListener(event, (event) => {
    if (!("closest" in event.target)) return;
    const targetElement = event.target.closest(selector);
    if (targetElement) {
      callback(event, targetElement);
    }
  });
};
